export const environment = {
  production: true,
  version: '0.0.103b',
  url: 'https://api.uat.autoactioncloud.com/',
  carletonVersion: 'v2.0',
  carletonAmortizationVersion: 'v1.1'
};
